module.exports = __webpack_public_path__ + "static/media/watersports.4be67579.png";